<template>
  <div class="authentication-wrapper authentication-basic container-p-y">
    <div class="authentication-inner">
      <div class="card">
        <div class="card-body">
          <!-- Logo -->
          <div class="app-brand justify-content-center">
            <a href="/" class="app-brand-link gap-2">
              <span class="app-brand-logo demo">
                  <img src="/logo.svg" alt="EDCTP Logo">
              </span>
            </a>
          </div>

          <div style="text-align: center; margin-bottom: 2rem;">
            <h4 class="mb-2">Recover my password</h4>
            <p class="mb-4">Forgot your password? No problem. Just let us know your email address and we will email you a password reset link that will allow you to choose a new one.</p>
          </div>

          <form @submit.prevent="handleForgotPassword">
            <div class="mb-3">
              <label for="email" class="form-label">Email</label>
              <input
                type="email"
                class="form-control"
                id="email"
                v-model="form.email"
                :class="{ 'is-invalid': errors.email }"
                placeholder="Enter your email"
                autofocus
                required
              />
              <div class="invalid-feedback" v-if="errors.email">
                {{ errors.email }}
              </div>
            </div>

            <div class="mb-3">
              <button class="btn btn-primary d-grid w-100" type="submit" :disabled="loading">
                <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
                {{ loading ? 'Sending...' : 'Send Reset Link' }}
              </button>
            </div>
          </form>

          <div class="text-center">
            <router-link to="/login" class="d-flex align-items-center justify-content-center">
              <i class="bi bi-chevron-left scaleX-n1-rtl me-1"></i>
              Back to login
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ForgotPassword',

  data() {
    return {
      form: {
        email: ''
      },
      errors: {},
      success: false
    }
  },

  computed: {
    ...mapGetters('auth', ['loading', 'error']),

    appName() {
      return process.env.VUE_APP_NAME || 'EDCTP Admin'
    }
  },

  methods: {
    ...mapActions('auth', ['forgotPassword']),

    async handleForgotPassword() {
      this.errors = {}
      this.success = false

      try {
        await this.forgotPassword(this.form.email)
        this.success = true
        alert('Password reset link sent! Check your email.')
      } catch (error) {
        if (error.response?.data?.errors) {
          this.errors = error.response.data.errors
        }
      }
    }
  }
}
</script>

<style scoped>
.authentication-wrapper {
  display: flex;
  flex-basis: 100%;
  min-height: 100vh;
  width: 100%;
  background-image: url('/public/19.jpg');
  background-size: cover;
  background-repeat: no-repeat
}

.authentication-inner {
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 55, 61, 0.6);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.card {
  box-shadow: 0 0.25rem 1rem rgba(161, 172, 184, 0.45);
  border: 0;
  max-width: 400px;
  margin: 0 auto;
}

.app-brand {
  margin-bottom: 1.5rem;
}

.app-brand-text {
  color: #009CAD;
  font-size: var(--font-size-xl);
}
</style>
